// export const BASE_URL = "https://ecommerce-8w8d.onrender.com";
export const BASE_URL = "https://military-personnel-database-management.onrender.com";

